import * as actions from '../actions';
import {
    addNotification,
    addAdminNotification
} from './notificationActions';
import {
    getCollection
} from '../../constant';

export const createTask = (task, preTask) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        dispatch({
            type: actions.CREATE_TASK_START
        });
        const firestore = getFirestore();
        const profile = getState().firebase.profile
        const profileUid = getState().firebase.auth.uid

        let fun;
        if (preTask) { //edit
            fun = firestore.update({
                collection: getCollection(profile, 'tasks'),
                doc: preTask.id
            }, {
                ...task,
                updatedAt: new Date(),
                updatedBy: profile.id,
            })

        } else { // Create
            fun = firestore.add({
                collection: getCollection(profile, 'tasks')
            }, {
                ...task,
                createdAt: new Date(),
                authorId: profile.id,
            })
        }

        fun.then((createdTask) => {
            let id = '';
            try {
                id = createdTask.Tv.path.segments[3]
            } catch (e) { }
            dispatch({
                type: actions.CREATE_TASK_SUCCESS,
                payload: task
            });

            let assigned = []
            let updated = []
            if (preTask && preTask.id) { //Edit
                task.assignee.forEach(userNew => {
                    let isExist = false;
                    preTask.assignee.forEach(userPre => {
                        if (userNew.id == userPre.id) {
                            isExist = true;
                            updated.push(userNew);
                        }
                    });
                    if (!isExist) {
                        assigned.push(userNew);
                    }
                });

            } else {
                assigned = task.assignee;
            }

            const notiData = {
                from: profileUid,
                taskId: preTask ? preTask.id : id,
                taskTitle: task.title,
                fromName: profile.displayName,
            };

            /** Add Notification */
            assigned.forEach((user) => {
                addNotification(firestore, {
                    ...notiData,
                    to: user.id,
                    type: 'NewTask',
                    title: `New task(${task.title}) assign to you by ${profile.displayName}`,
                }, profile)
            })

            console.log("preTask Jasu : ", preTask)

            if (preTask.addComment) {
                /** Add comment Notification */
                let notiData1 = {
                    ...notiData,
                    type: 'AddTaskComment',
                    title: `New comment added in your task(${task.title}) by ${profile.displayName}`,
                }
                updated.forEach((user) => {
                    addNotification(firestore, {
                        ...notiData1,
                        to: user.id,
                    }, profile)
                })

                addAdminNotification(firestore, notiData1, profile);

            } else if (preTask.edit) {
                /** Edit Notification */
                updated.forEach((user) => {
                    addNotification(firestore, {
                        ...notiData,
                        to: user.id,
                        type: 'UpdateTask',
                        title: `Task(${task.title}) has been updated by ${profile.displayName}`,
                    }, profile)
                })
            } else if (preTask.complete) {
                /** Complete Notification */
                let notiData1 = {
                    ...notiData,
                    type: 'CompleteTask',
                    title: `Task(${task.title}) has been completed by ${profile.displayName}`,
                }
                updated.forEach((user) => {
                    addNotification(firestore, {
                        ...notiData1,
                        to: user.id,
                    }, profile)
                })
                addAdminNotification(firestore, notiData1, profile);
            } else if (preTask.reopen) {
                /** Reopen Notification */
                updated.forEach((user) => {
                    addNotification(firestore, {
                        ...notiData,
                        to: user.id,
                        type: 'ReopenTask',
                        title: `Task(${task.title}) has been reopened by ${profile.displayName}`,
                    }, profile)
                })

            } else {
                console.log('Default Case ', preTask)
            }

        }).catch((err) => {
            dispatch({
                type: actions.CREATE_TASK_ERROR,
                payload: err
            })
        })
    }
}

export const createTaskReset = () => {
    return (dispatch) => {
        dispatch({
            type: actions.CREATE_TASK_RESET
        });
    }
}


export const getTaskFiles = (taskId) => {
    return (dispatch, getState, {
        getFirebase,
        getFirestore
    }) => {
        dispatch({
            type: actions.GET_TASK_FILES_START
        });

        const firebase = require("firebase/app");
        var storageRef = firebase.storage().ref('task-files/' + taskId);
        storageRef.listAll().then(function (result) {
            const allURLS = [];
            if (!result.items.length) {
                dispatch({
                    type: actions.GET_TASK_FILES_SUCCESS,
                    payload: allURLS
                });
            }
            result.items.forEach(function (imageRef, i) {
                imageRef.getDownloadURL().then(function (url) {
                    // console.log("url : ", url)
                    allURLS.push(url);
                    if (result.items.length - 1 == i) {
                        // console.log("allURLS : ", allURLS, result.items.length)

                        dispatch({
                            type: actions.GET_TASK_FILES_SUCCESS,
                            payload: allURLS
                        });
                    }
                }).catch(function (error) {
                    // Handle any errors
                });
            });
        }).catch(function (error) {
            dispatch({
                type: actions.GET_TASK_FILES_ERROR,
                payload: error

            });
        });




    }
}